import React from 'react';
import PageContainer from '../../../components/PageContainer';
import { PageHeader, Panel } from '../../../components/ui';
import CreateStoryForm from '../../../components/CreateStoryForm';

/** Create a story by hand (author + story fields + main image and video). */
const CreateStory = () => (
    <PageContainer constrained>
        <PageHeader
            backTo={{ to: '/stories', label: 'Stories' }}
            eyebrow="Customer Stories"
            title="Create story"
            subtitle="The image and the video must be uploaded before the story can be saved."
        />
        <Panel>
            <CreateStoryForm />
        </Panel>
    </PageContainer>
);

export default CreateStory;
